import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@bingads-webui-react/fabric-control';
import { PropertyLabel } from './property-label';
import { PropertyData } from './property-data';

export const PropertyRow = ({
  propertyLabel, propertyLabelDynamic, propertyData, propertyDataDynamic, children,
}) => (
  <div>
    <Stack horizontal disableShrink>
      <PropertyLabel {...propertyLabel} {...propertyLabelDynamic} />
      <PropertyData {...propertyData} {...propertyDataDynamic}>
        {children}
      </PropertyData>
    </Stack>
  </div>
);

PropertyRow.propTypes = {
  propertyData: PropTypes.shape({}),
  propertyDataDynamic: PropTypes.shape({}),
  propertyLabel: PropTypes.shape({}).isRequired,
  propertyLabelDynamic: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

PropertyRow.defaultProps = {
  propertyData: null,
  propertyDataDynamic: null,
  propertyLabelDynamic: null,
  children: null,
};
